import CitySEOHead from "@/components/feature/CitySEOHead";
import MarcoIslandHeroSection from "./components/HeroSection";
import MarcoIslandStickyNav from "./components/StickyNav";
import MarcoIslandProcessingTimeSection from "./components/ProcessingTimeSection";
import MarcoIslandServicesSection from "./components/ServicesSection";
import MarcoIslandLocalAreaSection from "./components/LocalAreaSection";
import MarcoIslandTravelTimingSection from "./components/TravelTimingSection";
import MarcoIslandDestinationsSection from "./components/DestinationsSection";
import MarcoIslandTestimonialsSection from "./components/TestimonialsSection";
import MarcoIslandAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MarcoIslandComparisonSection from "./components/ComparisonSection";
import MarcoIslandMistakesSection from "./components/MistakesSection";
import MarcoIslandHowItWorksSection from "./components/HowItWorksSection";
import MarcoIslandFAQSection, { faqs } from "./components/FAQSection";
import MarcoIslandHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MarcoIslandFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MarcoIslandPage() {
  return (
    <div className="min-h-screen bg-white">
      <CitySEOHead
        city="Marco Island"
        state="Florida"
        stateAbbr="FL"
        route="/marco-island"
        title="Emergency Passport Marco Island, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Marco Island, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Collier County travelers, boating enthusiasts, and luxury vacationers."
        geoPlacename="Marco Island, Florida"
        geoPosition="25.9400;-81.6967"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <MarcoIslandHeroSection />
      <MarcoIslandStickyNav />
      <MarcoIslandProcessingTimeSection />
      <MarcoIslandServicesSection />
      <MarcoIslandLocalAreaSection />
      <MarcoIslandTravelTimingSection />
      <MarcoIslandDestinationsSection />
      <MarcoIslandTestimonialsSection />
      <MarcoIslandAcceptanceFacilitiesSection />
      <MarcoIslandComparisonSection />
      <MarcoIslandMistakesSection />
      <MarcoIslandHowItWorksSection />
      <MarcoIslandFAQSection />
      <MarcoIslandHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/marco-island" state="FL" />
      <MarcoIslandFinalCTA />
    </div>
  );
}